import { render, staticRenderFns } from "./SubTile.vue?vue&type=template&id=1171e134&"
import script from "./SubTile.vue?vue&type=script&lang=ts&"
export * from "./SubTile.vue?vue&type=script&lang=ts&"
import style0 from "./SubTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports